import { render, staticRenderFns } from "./BuyerDash.vue?vue&type=template&id=3d99fbd6"
import script from "./BuyerDash.vue?vue&type=script&lang=js"
export * from "./BuyerDash.vue?vue&type=script&lang=js"
import style0 from "./BuyerDash.vue?vue&type=style&index=0&id=3d99fbd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports